import { useQueryClient } from '@tanstack/react-query';
import { cacheKeys, useCustomMutation } from '../../graphql';

export interface ResolveAccessRequestInput {
  issueId: string;
  decision: 'APPROVED' | 'DENIED';
}

export const useResolveAccessRequest = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useCustomMutation({
    query: RESOLVE_ACCESS_REQUEST,
    options: {
      onSuccess: async () => {
        // Invalidate issue message cache so Approve/Deny buttons reflect the resolved status
        await queryClient.invalidateQueries({
          queryKey: cacheKeys('issueMessage').all,
        });
        // Invalidate activity/issue cache so the card updates in the inbox
        await queryClient.invalidateQueries({
          queryKey: cacheKeys('issue').all,
        });
      },
    },
  });

  const resolveAccessRequest = async (input: ResolveAccessRequestInput) => {
    return mutateAsync({ input });
  };

  return { resolveAccessRequest, isLoading: isPending };
};

const RESOLVE_ACCESS_REQUEST = `
  mutation Asset($input: ResolveAccessRequestInput!) {
    asset {
      resolveAccessRequest(input: $input) {
        success
        message
      }
    }
  }
`;
